import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import App from './App.vue'
import router from './router'
import store from './store'
import NProgress from 'vue-nprogress'
import VueHtmlToPaper from 'vue-html-to-paper'
// import FirebaseAuthService from './services/firebase'
import NeoAuthService from './services/authenticate'
import DevDeb from './services/devdeb'
import roleutility from './services/roleutil'
import ApplicantAuthService from './services/applicantauth'
import VueLayers from 'vuelayers'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import axiosRetry from 'axios-retry'

import NeoTheme from './services/theme'
import neoNotify from './services/neonotify'

import { i18n } from '@/plugins/i18n'

import Echo from 'laravel-echo'

import CKEditor from '@ckeditor/ckeditor5-vue2'
import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

import {
  Avatar,
  Collapse,
  List,
  TreeSelect,
  Rate,
  Breadcrumb,
  InputNumber,
  Steps,
  Message,
  Upload,
  Button,
  Layout,
  Table,
  Icon,
  Progress,
  Radio,
  Dropdown,
  Menu,
  Carousel,
  Input,
  Calendar,
  Badge,
  Slider,
  Form,
  Tooltip,
  Select,
  Switch,
  Tag,
  Affix,
  Spin,
  Alert,
  Checkbox,
  Tabs,
  Pagination,
  notification,
  Drawer,
  Cascader,
  DatePicker,
  TimePicker,
  Divider,
  Modal,
  Popconfirm,
  Popover,
  Skeleton,
} from 'ant-design-vue'

import './global.scss'

Vue.use(BootstrapVue)
Vue.use(VueLayers)
Vue.use(Avatar)
Vue.use(Collapse)
Vue.use(List)
Vue.use(Divider)
Vue.use(Button)
Vue.use(Rate)
Vue.use(TreeSelect)
Vue.use(Breadcrumb)
Vue.use(Layout)
Vue.use(Table)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Carousel)
Vue.use(Input)
Vue.use(Calendar)
Vue.use(Badge)
Vue.use(Slider)
Vue.use(Form)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Tag)
Vue.use(Affix)
Vue.use(Spin)
Vue.use(Alert)
Vue.use(Checkbox)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Message)
Vue.use(Steps)
Vue.use(InputNumber)
Vue.use(Drawer)
Vue.use(Switch)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Modal)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(Skeleton)
Vue.use(notification)
Vue.use(CKEditor)
Vue.use(Donut)
Vue.use(Chartkick.use(Chart))

window.jsonToFormData = require('json-form-data')
window.Pusher = require('pusher-js')
const echoOptions = {
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_KEY,
  wsHost: process.env.VUE_APP_SERVER_HOST,
  wsPort: 6001,
  wssPort: 6001,
  encrypted: true,
  enabledTransports: ['ws', 'wss'],
  authEndpoint: process.env.VUE_APP_SERVER_URL + '/api/broadcasting/auth',
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      Accept: 'application/json',
    },
  },
  disableStats: true,
}
window.Echo = new Echo(echoOptions)
Vue.prototype.$notification = notification
const base = axios.create({
  baseURL: process.env.VUE_APP_SERVER_URL,
})
// Get and assign access_token to request
base.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('access_token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
base.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response && error.response.data) {
    // logout user if token expired or unauthorized
    if (error.response.status === 401) {
      router.push('/system/login')
      store.commit('UPDATE_TOKEN', { token: null })
      localStorage.removeItem('access_token')
      store.commit('UPDATE_USER', { user: {} })
      localStorage.removeItem('user')
      location.reload()
    }
    return Promise.reject(error.response.data)
  }
  return Promise.reject(error)
})
axiosRetry(base, { retries: 3 })
Vue.prototype.$http = base
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
Vue.prototype.$info = Modal.info
Vue.prototype.$message = Message
// event bus
Vue.prototype.$eventBus = new Vue()
Vue.use(NProgress)
// Vue.use(FirebaseAuthService)
Vue.use(NeoAuthService)
Vue.use(DevDeb)
Vue.use(roleutility)
Vue.use(ApplicantAuthService)
Vue.use(NeoTheme)
Vue.use(neoNotify)
Vue.use(VuePageTitle, {
  prefix: 'Power Campus | ',
  router,
})
const printOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=no',
    'scrollbars=yes',
  ],
  styles: [
    'https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css',
    '/resources/print/style.css',
  ],
}
Vue.use(VueHtmlToPaper, printOptions)
Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })
new Vue({
  router,
  store,
  nprogress,
  i18n,
  render: h => h(App),
}).$mount('#app')
